import {values} from './ClientLocatorData';

/**
 * Hash to validate last letter of Eroski Client Locator.
 */
const locatorKeyHash = {
    0: 'E',
    1: 'T',
    2: 'R',
    3: 'W',
    4: 'A',
    5: 'G',
    6: 'M',
    7: 'Y',
    8: 'F',
    9: 'P',
    10: 'D',
    11: 'X',
    12: 'B',
    13: 'N',
    14: 'J',
    15: 'Z',
    16: 'S',
    17: 'Q',
    18: 'V',
    19: 'H',
    20: 'L',
    21: 'C',
    22: 'K',
};

const errorMessage = values['b2bweberoski'].errorMessageClientLocator;

/**
 * Check if value parameter validate 'EVE/[0-9]/[0-9]/[A-Z]' regular expression, and 
 * last letter must mutch with the letter of 'locatorKeyHash' in the position (first number + second number % 23) 
 * 
 * @param {string} value  Client Locator to validate
 * @returns {boolean} true if value is valid Client Locator.
 */
export function validate(value) {

    if (!value || value.trim() === '' || value.trim().length < 9) {
        throw new Error(errorMessage);
    }
    value = value.trim();

    const splitted = value.split('/');
    if(splitted.length !== 4){
        throw new Error(errorMessage);
    }

    const prefix = splitted[0].toUpperCase();
    const firstNumber = splitted[1];
    const secondNumber = splitted[2];
    const lastLetter = splitted[3].toUpperCase();
    const numbersOnlyRegex = /^\d+$/;
    if (prefix !== 'EVE' || !numbersOnlyRegex.test(firstNumber) || !numbersOnlyRegex.test(secondNumber)) {
        throw new Error(errorMessage);
    }

    const quotient = Number.parseInt(firstNumber + secondNumber) % 23;
    
    if (locatorKeyHash[String(quotient)] !== lastLetter) {
        throw new Error(errorMessage);
    }

    return true;
}


// WEBPACK FOOTER //
// ./src/components/Reservation/Validators/ClientLocator.b2bweberoski.js